import { useContext } from "react";
import { AppContext } from "../App";
import { getCurrentYear } from "../Helpers";
import { MdEmail, MdLocationPin, MdPhone } from "react-icons/md";
import { IoLogoWhatsapp } from "react-icons/io5";
import footerBg from "../assets/kilimanjaro.jpg";

export default function Footer() {
  const appContext = useContext(AppContext);

  const quickLinks = [
    { label: "Home", item: "home" },
    { label: "About Us", item: "about_us" },
    { label: "Adventure", item: "services", subItem: "adventure" },
    { label: "Safaris", item: "services", subItem: "safaris" },
    { label: "Trekking", item: "services", subItem: "trekking" },
    { label: "Zanzibar", item: "services", subItem: "zanzibar" },
    { label: "Contact", item: "contact_us" },
  ];

  const phoneContacts = [
    {
      label: "+255676808073",
      tel: "tel:+255676808073",
      whatsapp: "https://wa.me/255676808073",
    },
    {
      label: "+255673306622",
      tel: "tel:+255673306622",
      whatsapp: "https://wa.me/255673306622",
    },
  ];

  return (
    <footer className="footer-classic" style={{ backgroundImage: `url(${footerBg})` }}>
      <div className="footer-classic-overlay" />
      <div className="container position-relative">
        <div className="footer-classic-card">
          <div className="row g-4">
            <div className="col-lg-5">
              <h5 className="footer-classic-title font-semi-bold mb-2">Kwetu Africa Adventures</h5>
              <p className="footer-classic-text mb-0">
                Curated safari, trekking, and island journeys across Tanzania and East Africa.
              </p>
            </div>

            <div className="col-lg-3">
              <h6 className="footer-classic-subtitle font-semi-bold mb-3">Quick Links</h6>
              <div className="d-flex flex-column gap-2">
                {quickLinks.map((link) => (
                  <button
                    key={link.label}
                    onClick={() => appContext.navTo({ item: link.item, subItem: link.subItem })}
                    className="footer-classic-link"
                  >
                    {link.label}
                  </button>
                ))}
              </div>
            </div>

            <div className="col-lg-4">
              <h6 className="footer-classic-subtitle font-semi-bold mb-3">Contact</h6>
              <div className="d-flex flex-column gap-2">
                <p className="footer-classic-contact mb-0">
                  <MdLocationPin size={18} />
                  <span>Arusha, Tanzania</span>
                </p>

                {phoneContacts.map((phone) => (
                  <div key={phone.label} className="footer-classic-contact footer-classic-phone mb-0">
                    <span className="d-inline-flex align-items-center" style={{ gap: 8 }}>
                      <MdPhone size={18} />
                      <a href={phone.tel} className="footer-classic-mail">
                        {phone.label}
                      </a>
                    </span>
                    <a
                      href={phone.whatsapp}
                      target="_blank"
                      rel="noreferrer"
                      className="footer-classic-whatsapp"
                      aria-label={`WhatsApp ${phone.label}`}
                    >
                      <IoLogoWhatsapp size={16} />
                      WhatsApp
                    </a>
                  </div>
                ))}

                <p className="footer-classic-contact mb-0">
                  <MdEmail size={18} />
                  <a href="mailto:info@kwetuafricaadventures.com" className="footer-classic-mail">
                    info@kwetuafricaadventures.com
                  </a>
                </p>
              </div>
            </div>
          </div>

          <div className="footer-classic-bottom mt-4 pt-3 text-center">
            <p className="mb-1">&copy; {getCurrentYear()} Kwetu Africa Adventures. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
